<template>
  <b-card>
    <b-row>
      <b-col sm="12" lg="6">
        <div class="mb-1">
          Menu
          <span class="text-muted font-italic">(resolusi 350px x 100px)</span>
        </div>
        <div id="dropzone-logo-menu" class="dropzone dropzone-area mb-3">
          <div class="dz-message">
            Drop files here or click button to upload.
          </div>
        </div>
      </b-col>
      <b-col sm="12" lg="6">
        <div class="mb-1">
          Footer
          <span class="text-muted font-italic">(resolusi 350px x 100px)</span>
        </div>
        <div id="dropzone-logo-footer" class="dropzone dropzone-area mb-3">
          <div class="dz-message">
            Drop files here or click button to upload.
          </div>
        </div>
      </b-col>
      <b-col sm="12" lg="6">
        <div class="mb-1">
          Login Banner
          <span class="text-muted font-italic">(resolusi 350px x 100px)</span>
        </div>
        <div id="dropzone-logo-login-banner" class="dropzone dropzone-area mb-3">
          <div class="dz-message">
            Drop files here or click button to upload.
          </div>
        </div>
      </b-col>
      <b-col sm="12" lg="6">
        <div class="mb-1">
          Login Logo
          <span class="text-muted font-italic">(resolusi 350px x 100px)</span>
        </div>
        <div id="dropzone-logo-login-logo" class="dropzone dropzone-area mb-3">
          <div class="dz-message">
            Drop files here or click button to upload.
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="d-flex justify-content-end">
        <b-button
          type="button"
          class="mr-1"
          variant="light"
          @click="clearAllFiles"
        >
          Cancel
        </b-button>
        <b-button
          type="button"
          :disabled="isLoading"
          variant="primary"
          @click="saveLogo"
        >
          Save
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, BButton } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
  },

  data() {
    return {
      isLoading: false,
      logoMenu: '',
      logoFooter: '',
      logoLoginBanner: '',
      logoLoginLogo: '',
      menuDzIns: '',
      footerDzIns: '',
      loginBannerDzIns: '',
      loginLogoDzIns: '',
      thumbnail: ''
    }
  },

  mounted() {
    setTimeout(() => {
      this.initDropzone()
      this.thumbnail = this.$store.state.app.settings.logo
      console.log(this.thumbnail)
    }, 2300);
    setTimeout(() => {
      var mockFile = {
          type: 'image/png',
          accepted: true,
          url: this.thumbnail.menu
      };
      this.menuDzIns.files.push(mockFile);
      this.menuDzIns.emit("addedfile", mockFile);
      this.menuDzIns.emit("thumbnail", mockFile, this.thumbnail.menu);
      this.menuDzIns.emit("complete", mockFile); 

      var mockFile = {
          type: 'image/png',
          accepted: true,
          url: this.thumbnail.footer
      };
      this.footerDzIns.files.push(mockFile);
      this.footerDzIns.emit("addedfile", mockFile);
      this.footerDzIns.emit("thumbnail", mockFile, this.thumbnail.footer);
      this.footerDzIns.emit("complete", mockFile); 

      var mockFile = {
          type: 'image/png',
          accepted: true,
          url: this.thumbnail.loginBanner
      };
      this.loginBannerDzIns.files.push(mockFile);
      this.loginBannerDzIns.emit("addedfile", mockFile);
      this.loginBannerDzIns.emit("thumbnail", mockFile, this.thumbnail.loginBanner);
      this.loginBannerDzIns.emit("complete", mockFile); 

      var mockFile = {
          type: 'image/png',
          accepted: true,
          url: this.thumbnail.loginLogo
      };
      this.loginLogoDzIns.files.push(mockFile);
      this.loginLogoDzIns.emit("addedfile", mockFile);
      this.loginLogoDzIns.emit("thumbnail", mockFile, this.thumbnail.loginLogo);
      this.loginLogoDzIns.emit("complete", mockFile); 
    }, 2400);
  },

  destroyed() {
    this.menuDzIns.disable()
    this.footerDzIns.disable()
    this.loginBannerDzIns.disable()
    this.loginLogoDzIns.disable()
  },

  methods: {
    initDropzone() {
      const options = {
        url: `${process.env.VUE_APP_API_HOST}/api/settings/logo-upload`,
        maxFiles: 1,
        autoProcessQueue: true,
        autoQueue: true,
        addRemoveLinks: true,
        acceptedFiles: 'image/png,image/jpeg,image/jpg',
        headers: {
          Authorization: `Bearer ${this.$store.getters['oauth/getToken']}`,
        },
      }
      const { makeLogoFooter, makeLogoMenu, makeLogoLoginBanner, makeLogoLoginLogo, deleteTempFile } = this

      this.menuDzIns = new window.Dropzone('#dropzone-logo-menu', {
        ...options,
        init() {
          this.on('success', (file, res) => makeLogoMenu(res.data.path))
          this.on('removedfile', () => {
            deleteTempFile('menu')
          })
        },
      })

      this.footerDzIns = new window.Dropzone('#dropzone-logo-footer', {
        ...options,
        init() {
          this.on('success', (file, res) => makeLogoFooter(res.data.path))
          this.on('removedfile', () => {
            deleteTempFile('footer')
          })
        },
      })

      this.loginBannerDzIns = new window.Dropzone('#dropzone-logo-login-banner', {
        ...options,
        init() {
          this.on('success', (file, res) => makeLogoLoginBanner(res.data.path))
          this.on('removedfile', () => {
            deleteTempFile('loginBanner')
          })
        },
      })

      this.loginLogoDzIns = new window.Dropzone('#dropzone-logo-login-logo', {
        ...options,
        init() {
          this.on('success', (file, res) => makeLogoLoginLogo(res.data.path))
          this.on('removedfile', () => {
            deleteTempFile('loginLogo')
          })
        },
      })
    },

    deleteTempFile(file) {
      const deleteFileTempUrl = '/settings/logo-delete'

      if (file === 'footer') {
        if (this.logoFooter) {
          this.$http
            .post(deleteFileTempUrl, {
              path: this.logoFooter,
            })
            .then(() => {
              this.logoFooter = ''
            })
            .catch(err => {
              console.error(err)
            })
        }
      } else if (file === 'menu') {
        if (this.logoMenu) {
          this.$http
            .post(deleteFileTempUrl, {
              path: this.logoMenu,
            })
            .then(() => {
              this.logoMenu = ''
            })
            .catch(err => {
              console.error(err)
            })
        }
      } else if (file === 'loginBanner') {
        if (this.logoLoginBanner) {
          this.$http
            .post(deleteFileTempUrl, {
              path: this.logoLoginBanner,
            })
            .then(() => {
              this.logoLoginBanner = ''
            })
            .catch(err => {
              console.error(err)
            })
        }
      } else if (file === 'loginLogo') {
        if (this.logoLoginLogo) {
          this.$http
            .post(deleteFileTempUrl, {
              path: this.logoLoginLogo,
            })
            .then(() => {
              this.logoLoginLogo = ''
            })
            .catch(err => {
              console.error(err)
            })
        }
      }
    },

    makeLogoFooter(path) {
      this.logoFooter = path
    },
    makeLogoMenu(path) {
      this.logoMenu = path
    },

    makeLogoLoginBanner(path) {
      this.logoLoginBanner = path
    },

    makeLogoLoginLogo(path) {
      this.logoLoginLogo = path
    },

    clearAllFiles() {
      this.menuDzIns.removeAllFiles()
      this.footerDzIns.removeAllFiles()
      this.loginBannerDzIns.removeAllFiles()
      this.loginLogoDzIns.removeAllFiles()
    },

    saveLogo() {
      this.isLoading = true
      this.$http
        .post('/settings/logo', {
          menu: this.logoMenu,
          footer: this.logoFooter,
          loginBanner: this.logoLoginBanner,
          loginLogo: this.logoLoginLogo,
        })
        .then(() => {
          this.$notif(
            'Success',
            'Logo has been successfully updated.',
            'success'
          )
          this.logoMenu = ''
          this.logoFooter = ''
          this.logoLoginBanner = ''
          this.logoLoginLogo = ''
          this.$store.dispatch('app/fetchGlobalSettings')
        })
        .catch(err => {
          this.$notif('Error', `${err.message}`, 'error')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style scoped>
/deep/ .dz-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>
